module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/eye-3c297e786c614f9de09e439531c1460e.svg&quot;;"